import apiClient from "./client";

export async function updateCompany(currentSlug, companyName, companySlug) {
  const res = await apiClient.post("/api/update-company", {
    current_slug: currentSlug,
    company_name: companyName,
    company_slug: companySlug,
  });
  if (!res.ok) throw new Error("Помилка оновлення даних");
  return res.json();
}

export async function downloadPdfLead(email) {
  const res = await apiClient.post("/api/download-pdf", { email: email.trim(), consent: true, source: "download-pdf" }, { auth: false });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Помилка з'єднання");
  }
  return res.json();
}
